import './styles/casetile.css';
import { getAIDetectionConfig, getPreloadIcon, getPreloadTooltip, getReportStatusConfig } from './helper/BlitzSessionHelper';
import CustomToolTipHost from '../../../../components/CustomToolTipHost/CustomToolTipHost';

const CaseTile = ({ case: dicomCase, isActive, onClick }) => {

  const reportStatus = getReportStatusConfig(dicomCase.reportDoneStatus);
  const aiDetection = getAIDetectionConfig(dicomCase.aiProcessed, dicomCase.maxAiEmergency);

  return (
    <div
      className={`case-tile ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      <div className="case-tile-header">
        <div className="modality-section">
          <div className="modality-badge">
            {dicomCase.modality}
          </div>
          
          {dicomCase.emergency && !dicomCase.nonMedicalEmergency && (
            <CustomToolTipHost content={"Medical Emergency"}>
              <div className="emergency-badge">
                !
              </div>
            </CustomToolTipHost>
          )}

          {dicomCase.emergency && dicomCase.nonMedicalEmergency && (
            <CustomToolTipHost content={"Non Medical Emergency"}>
              <div className="non-medical-emergency-badge">
                !
              </div>
            </CustomToolTipHost>
          )}
          
          {aiDetection && (
            <CustomToolTipHost content={aiDetection.label}>
              <div className={`ai-badge ${aiDetection.className} ${aiDetection.animate ? 'animate' : ''}`}>
                {aiDetection.text}
              </div>
            </CustomToolTipHost>
          )}
        </div>
        
        <div className="status-indicators">
          <div className={`report-status ${reportStatus.className}`}>
            {reportStatus.icon}
            <span>{reportStatus.label}</span>
          </div>
          
          <CustomToolTipHost content={getPreloadTooltip(dicomCase.prefetchStatus)}>
            <div className="preload-indicator">
              {getPreloadIcon(dicomCase.prefetchStatus)}
            </div>
          </CustomToolTipHost>
        </div>
      </div>
      <CustomToolTipHost content={`Description: ${dicomCase.description}`}>
        <div className="case-description">
          <div className="description-text">
            {dicomCase.description}
          </div>
        </div>
      </CustomToolTipHost>
      <div className="patient-details">
        <div className="patient-id-name">
          <CustomToolTipHost content={`PId: ${dicomCase.patientId}`}>
            <div className="ellipsis-text">{dicomCase.patientId}</div>
          </CustomToolTipHost>
          <span className="separator"> | </span>
          <CustomToolTipHost content={`PName: ${dicomCase.patientName}`}>
            <div className="ellipsis-text">{dicomCase.patientName}</div>
          </CustomToolTipHost>
        </div>
        <div className="patient-id-name">
          <CustomToolTipHost content={`Age: ${dicomCase.patientAge || '-'}`}>
            <div className="ellipsis-text">{dicomCase.patientAge || '-'}</div>
          </CustomToolTipHost> 
          <span className="separator"> | </span>
          <CustomToolTipHost content={`Gender: ${dicomCase.patientSex || '-'}`}>
            <div className="ellipsis-text">{dicomCase.patientSex || '-'}</div>
          </CustomToolTipHost>
          {/* {dicomCase.patientAge} | {dicomCase.patientSex} */}
        </div>
      </div>
    </div>
  );
};

export default CaseTile;